export default __webpack_public_path__ + "static/media/touchOne.5a145a33.svg";